module.exports = __webpack_public_path__ + "static/media/land-lot-large.52bc8ac0.png";